module.exports = __webpack_public_path__ + "static/media/business-owner-Google-Search-2.6a976c06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/business/business-owner-Google-Search-2.jpg
// module id = 769
// module chunks = 0